import { useTranslation } from 'react-i18next';
import { AlertCircle } from 'lucide-react';
import { FOCUS_RING, formatCount } from './toolbarConfig';

interface ActionRequiredButtonProps {
  count: number;
  active: boolean;
  onToggle: () => void;
}

/**
 * Orders waiting for the merchant — one tap from any tab, outside the Filter menu (owner 11-02).
 * Hidden when there is nothing to do, unless it is the list on screen (so it can be turned off).
 */
const ActionRequiredButton = ({ count, active, onToggle }: ActionRequiredButtonProps) => {
  const { t } = useTranslation();
  if (!count && !active) return null;
  const label = String(t('action_required')).trim();

  return (
    <button
      type='button'
      aria-pressed={active}
      onClick={onToggle}
      className={`inline-flex items-center gap-1.5 h-8 px-2.5 rounded-lg border border-solid text-[13px] font-semibold cursor-pointer shrink-0 ${FOCUS_RING} ${
        active
          ? 'border-sd-destructive bg-sd-destructive text-white'
          : 'border-sd-destructive/40 bg-sd-destructive/5 text-sd-destructive hover:bg-sd-destructive/10'
      }`}
    >
      <AlertCircle aria-hidden className='w-4 h-4' />
      {label}
      {count ? (
        <span
          className={`min-w-[18px] h-[18px] px-1 inline-flex items-center justify-center rounded-full text-[11px] font-bold tabular-nums ${
            active ? 'bg-white text-sd-destructive' : 'bg-sd-destructive text-white'
          }`}
        >
          {formatCount(count)}
        </span>
      ) : null}
    </button>
  );
};

export default ActionRequiredButton;
